<template>
    <div>

        <div class="tab">
            <a-tabs :active-key="activeKey" type="card-gutter" @change="tabClick">
                <a-tab-pane key="99" :title="$t('product.modelSummary')"></a-tab-pane>
                <a-tab-pane key="1" :title="$t('base.detail')"></a-tab-pane>
            </a-tabs>
        </div>

        <Table 
            ref="tableRef"
            v-if="activeKey != '99'"
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
        >
            <template v-slot:operate>
                <a-button type="primary" size="mini" v-permission="'setting.product.exportProductQuery'" :disabled="exporting" @click="handle('exportFile')">
                    <icon-download size="13" style="marginRight:5px;"/>
                    {{ $t('product.exportFile') }}
                </a-button>
                <a-divider direction="vertical" />
                <a-button type="primary" size="mini" @click="resetTableFilter">
                    <icon-undo size="13" style="marginRight:5px;"/>
                    {{ $t('product.resetTableFilter') }}
                </a-button>

                <div class="size_tab" v-if="activeKey == 1">
                    <a-tabs :active-key="activeKey2" type="line" @change="tabClickSub">
                        <a-tab-pane v-for="(item,index) in modelTypeKey" :key="index" :title="item"></a-tab-pane>
                    </a-tabs>
                </div>
            </template>

            <template v-slot:columns="{props}">
                <div v-if="props.column.key == 'inventory_by_warehouse'">
                    <div v-if="props.record.inventory_by_warehouse.length > 0">
                        <div v-for="(item,index) in props.record.inventory_by_warehouse" :key="index" style="font-size:12px;">
                            {{ item.label }}: <span style="display:inline-block;margin-left:10px"> {{ item.value }} </span>
                        </div>
                    </div>
                    <div v-else>-</div>
                </div> 
                <div v-if="props.column.key == 'scheduling_quantity'">
                    <div v-if="props.record.scheduling_quantity.length > 0">
                        <div v-for="(item,index) in props.record.scheduling_quantity" :key="index" style="font-size:12px;">
                            {{ item.label }}: <span style="display:inline-block;margin-left:10px"> {{ item.value }} </span>
                        </div>
                    </div>
                    <div v-else>-</div>
                </div> 
            </template>

            <template v-slot:searchFilter="{ props }">
                <div class="searchFilter">
                    <a-space direction="vertical">
                    <a-input :model-value="props.filterValue[0]" style="width:164px" @input="(value)=>props.setFilterValue([value])" />
                    <div class="searchFilter-footer">
                        <a-button  style="margin-right:10px" @click="props.handleFilterReset">{{ $t('base.reset') }}</a-button>
                        <a-button type="primary" @click="props.handleFilterConfirm">{{ $t('base.confirm2') }}</a-button>
                    </div>
                    </a-space>
                </div>
            </template>
        </Table>

        <Table 
            ref="allTableRef"
            v-if="activeKey == '99'"
            :table="allTable"
        >
            <template v-slot:operate>
                <a-button type="primary" size="mini" v-permission="'setting.product.exportProductQuery'" :disabled="exporting" @click="handle('exportSummaryFile')">
                    <icon-download size="13" style="marginRight:5px;"/>
                    {{ $t('product.exportFile') }}
                </a-button>
            </template>
        </Table>
    </div>
</template>

<script setup>
    import { onMounted, reactive, ref, watch, nextTick, h } from 'vue';
    import { ProductApi } from '@/api/ProductApi.js';
    import { StockOutApi } from '@/api/StockOutApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { ProductQuery } from './queryConfig/ProductListQuery.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';
    import { IconSearch } from '@arco-design/web-vue/es/icon';

    const localeStore = useLocale()

    const { t } = useI18n()

    const visible = ref(false)
    const activeKey = ref('99')
    const activeKey2 = ref(0)
    const operateType = ref('add')
    const rowData = ref()
    const queryForm = reactive(ProductQuery)
    const showForm = ref(false)
    const exporting = ref(false)
    const listData = ref([])
    const modelTypeKey = ref([])
    const tableRef = ref(null)
    const table = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'60',
                fixed:'left',
                align:'left',
            },
            {
                // title: 'SKU',
                title: t('product.sku'),
                dataIndex: 'sku',
                key:'sku',
                width:'170',
                ellipsis:true,
                tooltip:true,  
                align:'left',
                filterable: {
                    filter: (value, record) => record.sku.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            },
            {
                // title: '上市年份',
                title: t('product.modelYear'),
                dataIndex: 'model_year',
                key:'model_year',
                width:'120',
                ellipsis:true,
                tooltip:true,
                align:'left',
                // filterable: {
                //     filters: [
                //         {
                //             text: '2023',
                //             value: '2023',
                //         }, 
                //         {
                //             text: '2024',
                //             value: '2024',
                //         },
                //         {
                //             text: '2025',
                //             value: '2025',
                //         }
                //     ],
                //     filter: (value, row) => row.model_year.includes(value), //filterModelYear(),
                // }
            },
            {
                // title: '车型',
                title: t('product.model'),
                dataIndex: 'model',
                key:'model',
                width:'170',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '版本',
                title: t('product.version'),
                dataIndex: 'hf_version',
                key:'hf_version',
                width:'130',
                ellipsis:true,
                tooltip:true,
                align:'left',
                // filterable: {
                //     filters: [{
                //         text: 'Limited',
                //         value: 'Limited',
                //     }],
                //     filter: (value, row) => row.hf_version.includes(value),
                // }
                filterable: {
                    filters: [],
                    multiple: true,
                    filter: (value, row) =>{
                        return value.includes(row.hf_version) 
                    },
                }
            },
            {
                // title: '颜色',
                title: t('product.frameColor'),
                dataIndex: 'frame_color',
                key:'frame_color',
                width:'100',
                ellipsis:true,
                tooltip:true,
                align:'left',
                filterable: {
                    filters: [],
                    multiple: true,
                    filter: (value, row) =>{
                        return value.includes(row.frame_color) 
                    },
                }
            },
            {
                // title: '车架',
                title: t('product.frameShape'),
                dataIndex: 'frame_shape',
                key:'frame_shape',
                width:'120',
                ellipsis:true,
                tooltip:true,
                align:'left',
                filterable: {
                    filters: [],
                    multiple: true,
                    filter: (value, row) =>{
                        return value.includes(row.frame_shape) 
                    },
                }
            },
            {
                // title: '尺寸',
                title: t('product.frameSize'),
                dataIndex: 'frame_size',
                key:'frame_size',
                width:'110',
                ellipsis:true,
                tooltip:true,
                align:'left',
                filterable: {
                    filters: [],
                    multiple: true,
                    filter: (value, row) =>{
                        return value.includes(row.frame_size) 
                    },
                }
            },
            // {
            //     // title: '各仓库库存',
            //     title: t('product.warehouseInventory'),
            //     dataIndex: 'inventory_by_warehouse',
            //     key:'inventory_by_warehouse',
            //     width:'180',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'left',
            //     slotName:'slot'
            // },
            // {
            //     // title: 'ZU',
            //     title: t('product.zu'),
            //     dataIndex: 'zu',
            //     key:'zu',
            //     width:'80',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'left',
            // },
            {
                // title: 'HEPHA',
                title: t('product.hepha'),
                dataIndex: 'hepha',
                key:'hepha',
                width:'90',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '中央仓',
                title: t('product.centralWarehouse'),
                dataIndex: 'central_warehouse',
                key:'central_warehouse',
                width:'170',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: 'TTL',
                title: t('product.TTL'),
                dataIndex: 'inventory',
                key:'inventory',
                width:'80',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '退回数量',
                title: t('product.backOrder'),
                dataIndex: 'back_order_quantity',
                key:'back_order_quantity',
                width:'170',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            // {
            //     // title: '待生产总数',
            //     title: t('product.ToBeProduced'),
            //     dataIndex: 'produce_quantity_total',
            //     key:'produce_quantity_total',
            //     width:'180',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'left',
            // },
            {
                // title: '计划数量',
                title: t('product.schedulingQty'),
                dataIndex: 'scheduling_quantity',
                key:'scheduling_quantity',
                width:'160',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: '计划总数',
                title: t('product.schedulingTotalQty'),
                dataIndex: 'scheduling_quantity_total',
                key:'scheduling_quantity_total',
                width:'140',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '可用总库存',
                title: t('product.availabilityQty'),
                dataIndex: 'availability_quantity_total',
                key:'availability_quantity_total',
                width:'150',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '库龄',
                title: t('product.inventoryAge'),
                dataIndex: 'inventory_age',
                key:'inventory_age',
                width:'150',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            // {
            //     title: t('product.finishedPacking'),
            //     dataIndex: 'zu_in_stock_quantity',
            //     key:'zu_in_stock_quantity',
            //     width:'170',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'left',
            // },
        ],
        configs:{
            scroll:{
                x:1000,
                y:440,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:false,
        },
    })

    const allTable = ref({
        datas:[],
        columns:[
            {
                // title: '车型',
                title: t('product.model'),
                dataIndex: 'model',
                key:'model',
                // width:'200',
                ellipsis:true,
                tooltip:true,
                align:'center',
            },
            {
                // title: '版本',
                title: t('product.version'),
                dataIndex: 'hf_version',
                key:'hf_version',
                // width:'100',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            // {
            //     // title: 'ZU',
            //     title: t('product.zu'),
            //     dataIndex: 'zu_inventory',
            //     key:'zu_inventory',
            //     // width:'120',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'left',
            // },
            {
                // title: 'HEPHA',
                title: t('product.hepha'),
                dataIndex: 'hepha_inventory',
                key:'hepha_inventory',
                // width:'160',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '中央仓',
                title: t('product.centralWarehouse'),
                dataIndex: 'cwh_inventory',
                key:'cwh_inventory',
                // width:'180',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: 'TTL',
                title: t('product.TTL'),
                dataIndex: 'inventory_by_warehouse_total',
                key:'inventory_by_warehouse_total',
                // width:'180',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '退回数量',
                title: t('product.backOrder'),
                dataIndex: 'back_order_quantity',
                key:'back_order_quantity',
                width:'170',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            // {
            //     title: t('product.finishedPacking'),
            //     dataIndex: 'zu_in_stock_quantity',
            //     key:'zu_in_stock_quantity',
            //     width:'170',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'left',
            // },
            // {
            //     // title: '待生产总数',
            //     title: t('product.ToBeProduced'),
            //     dataIndex: 'produce_quantity_total',
            //     key:'produce_quantity_total',
            //     // width:'10',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'left',
            // },
        ],
        configs:{
            scroll:{
                x:1000,
                y:600,
            },
            stripe:false,
            bordered:true,
            hoverable:false,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:false,
            dataSpanMethod:({record, column, rowIndex, columnIndex})=>{
                // console.log({record, column, rowIndex, columnIndex},'kkkk')
                if (record.firstFlag && column.key === 'model' && record.model !== 'TTL') {
                    return {rowspan: record.length}
                }
                if (record.hfVersionTTLFlag && column.key === 'model') {
                    return {colspan: 2}
                }
            },
            rowClass:(record,rowIndex)=>{
                // console.log(record,rowIndex,'TTLRow')
                if (record.hf_version === 'TTL') {
                    return 'TTLRow'
                }
                return {};
            }
        },
    })

    const showFormPanel = (val)=>{
        showForm.value = val
    }

    const handle = (type,row)=>{
        switch(type){
            case 'search':
                getProductList()
                break;
            case 'reset':
                queryForm.formField.forEach(item=>{
                    if(item.key == 'warehouse') queryForm.formData[item.key] = []
                    else queryForm.formData[item.key] = ''
                })
                getProductList()
                break;
            case 'exportFile':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content: t('stock.exportConfirmTip'),
                    hideCancel:false,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        exportFile()
                    }
                });
                break;
            case 'exportSummaryFile':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content: t('stock.exportConfirmTip'),
                    hideCancel:false,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        exportSummaryFile()
                    }
                });
                break;
        }
    }

    // 列表查询-select
    const handleSelectChange = (val, opt, key)=>{
        getProductList()
    }

    // 列表查询-input
    const handleInputClear = (item, val)=>{
        getProductList()
    }
    const handlePressEnter = (val,item)=>{
        getProductList()
    }

     // 表格筛选条件重置
     const resetTableFilter = ()=>{
        tableRef.value.resetFilter()
    }

    const tabClick = (val)=>{
        activeKey.value = val
        switch(val){
            case '99':
                allTable.value.configs.loading = false 
                break;
            case '1':
                table.value.configs.loading = false
                break;
        }
    }

    // 点击tab
    const tabClickSub = (val)=>{
        activeKey2.value = val
        // let item = table.value.columns.find(i=> i.key == 'hf_version')

        nextTick(()=>{
            // switch(val){
            //     case 0: //  All Mountain 7 Carbon MY25
            //         // console.log(table.value.datas,'ddff')
            //         // item.filterable.filters = [{
            //         //     text: 'Limited',
            //         //     value: 'Limited',
            //         // }]
            //         resetTableFilter()
            //         break;
            //     case 1: // All Mountain 7 MY25
            //         // console.log(table.value.datas,'ddff 22')
            //         // item.filterable.filters = [{
            //         //     text: 'Performance',
            //         //     value: 'Performance',
            //         // },{
            //         //     text: 'Ultra',
            //         //     value: 'Ultra',
            //         // }]
            //         resetTableFilter()
            //         break;
            //     case 2: // City 7 MY25 
            //         // console.log(table.value.datas,'ddff 33')
            //         // item.filterable.filters = [{
            //         //     text: 'Longrange',
            //         //     value: 'Longrange',
            //         // },{
            //         //     text: 'Ultra',
            //         //     value: 'Ultra',
            //         // }]
            //         resetTableFilter()
            //         break;
            //     case 3: // MTB HT MY 
            //         // item.filterable.filters = [{
            //         //     text: 'Performance',
            //         //     value: 'Performance',
            //         // }]
            //         resetTableFilter()
            //         break;
            //     case 4: // Mountain 7 Carbon MY24 
            //         // item.filterable.filters = [{
            //         //     text: 'Longrange',
            //         //     value: 'Longrange',
            //         // },{
            //         //     text: 'Performance',
            //         //     value: 'Performance',
            //         // },{
            //         //     text: 'Ultra',
            //         //     value: 'Ultra',
            //         // }]
            //         resetTableFilter()
            //         break;
            //     case 5: // Mountain 7 MY24 
            //         // item.filterable.filters = [{
            //         //     text: 'Longrange',
            //         //     value: 'Longrange',
            //         // },{
            //         //     text: 'Performance',
            //         //     value: 'Performance',
            //         // },{
            //         //     text: 'Ultra',
            //         //     value: 'Ultra',
            //         // }]
            //         resetTableFilter()
            //         break;
            //     case 6: // Trekking 7 MY23
            //         // item.filterable.filters = [{
            //         //     text: 'Longrange',
            //         //     value: 'Longrange',
            //         // },{
            //         //     text: 'Performance',
            //         //     value: 'Performance',
            //         // },{
            //         //     text: 'Ultra',
            //         //     value: 'Ultra',
            //         // }]
            //         resetTableFilter()
            //         break;
            //     case 7: // Trekking 7 MY24
            //         // item.filterable.filters = [{
            //         //     text: 'Longrange',
            //         //     value: 'Longrange',
            //         // },{
            //         //     text: 'Performance',
            //         //     value: 'Performance',
            //         // },{
            //         //     text: 'Ultra',
            //         //     value: 'Ultra',
            //         // }]
            //         resetTableFilter()
            //         break;
            //     case 8: // Trekking 7 MY25
            //         // item.filterable.filters = [{
            //         //     text: 'Ultra+',
            //         //     value: 'Ultra+',
            //         // },{
            //         //     text: 'Limited',
            //         //     value: 'Limited',
            //         // }]
            //         resetTableFilter()
            //         break;
            //     case 9: // Trekking 7 SE MY2024
            //         // item.filterable.filters = [{
            //         //     text: 'Longrange',
            //         //     value: 'Longrange',
            //         // },{
            //         //     text: 'Ultra',
            //         //     value: 'Ultra',
            //         // }]
            //         resetTableFilter()
            //         break;
            //     case 10: // Trekking MY
            //         // item.filterable.filters = [{
            //         //     text: 'Performance',
            //         //     value: 'Performance',
            //         // }]
            //         resetTableFilter()
            //         break;
            //     case 11: // Urban 7 MY25
            //         // item.filterable.filters = [{
            //         //     text: 'Longrange',
            //         //     value: 'Longrange',
            //         // },{
            //         //     text: 'Ultra',
            //         //     value: 'Ultra',
            //         // }]
            //         resetTableFilter()
            //         break;
                
            // }
            resetTableFilter()
            table.value.configs.loading = false
            selectModel()
        })
    }

    // 导出
    const exportFile = async (type)=>{
        let param = {
            category_code:'627.501',
            need_back_order_flag: 1,
        }
        // if(queryForm.formData.warehouse.length > 0) param.warehouse = queryForm.formData.warehouse
        Message.success(t('base.exporting'))
        exporting.value = true
        table.value.configs.loading = true

        let res = await ProductApi.getInstance().exportProductQuery(param)
        if(!res.code){
            let blob = new Blob([res])
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download =  `${t('product.ebikeInventory')}.xlsx`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            Message.success(t('base.exportSuccess'))
            exporting.value = false
            table.value.configs.loading = false
        }else{  
            Message.error(res.msg)
        }
    }

    // 汇总导出
    const exportSummaryFile = async (type)=>{
        let param = {
            category_code:'627.501',
            need_back_order_flag: 1,
        }
        Message.success(t('base.exporting'))
        exporting.value = true
        table.value.configs.loading = true

        let res = await ProductApi.getInstance().exportSummaryQuery(param)
        if(!res.code){
            let blob = new Blob([res])
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download =  `${t('product.ebikeInventorySummary')}.xlsx`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            Message.success(t('base.exportSuccess'))
            exporting.value = false
            table.value.configs.loading = false
        }else{  
            Message.error(res.msg)
        }
    }

    const selectModel = ()=>{
            let modelType = {}
            modelTypeKey.value.forEach((item,index)=>{
                modelType[index] = item
            })
            // console.log(modelType,'modelType')

            table.value.datas = []
            let version_arr = [], color_arr = [], type_arr = [], size_arr = []

            if(listData.value !== null && listData.value[modelType[activeKey2.value]] && listData.value[modelType[activeKey2.value]].length > 0){
                    listData.value[modelType[activeKey2.value]].forEach((item,index)=>{
                        let schedulingQuantity = []
                        if(item.scheduling_quantity !== undefined){
                            for(let key in item.scheduling_quantity){
                                schedulingQuantity.push({
                                    label:key,
                                    value:item.scheduling_quantity[key] + ' ' + item.unit_code
                                })
                            }
                        }

                        table.value.datas.push({
                            No: index + 1,
                            sku: item.sku,
                            model_year: item.model_year == undefined? '-' : item.model_year == 'MY23'? '2023' : item.model_year == 'MY24'? '2024' : item.model_year == 'MY25'? '2025' : item.model_year == 'MY'? 'MY' : '-',
                            model: item.model == undefined? '-' : item.model,
                            hf_version: item.hf_version == undefined? '-' : item.hf_version,
                            frame_shape: item.frame_shape == undefined? '-' : item.frame_shape,
                            frame_size: item.frame_size == undefined? '-' : item.frame_size,
                            frame_color: item.frame_color == undefined? '-' : item.frame_color,
                            // inventory_by_warehouse: item.inventory_by_warehouse == undefined? [] : invantoryByWarehouse,
                            zu: !item.inventory_by_warehouse? '-' : item.inventory_by_warehouse.HF_OP01 === undefined? '-' : item.inventory_by_warehouse.HF_OP01,
                            hepha: !item.inventory_by_warehouse? '-' : item.inventory_by_warehouse.HFFG01 === undefined? '-' : item.inventory_by_warehouse.HFFG01,
                            central_warehouse: !item.inventory_by_warehouse? '-' : item.inventory_by_warehouse.HFFG05 === undefined? '-' : item.inventory_by_warehouse.HFFG05,
                            inventory: item.inventory_by_warehouse_total == undefined? '-' : item.inventory_by_warehouse_total, 
                            produce_quantity_total: item.produce_quantity_total == undefined? '-' : item.produce_quantity_total,
                            back_order_quantity: item.back_order_quantity === undefined? '-' : item.back_order_quantity,
                            scheduling_quantity: item.scheduling_quantity == undefined? [] : schedulingQuantity,
                            scheduling_quantity_total: item.scheduling_quantity_total == undefined? '-' : item.scheduling_quantity_total + ' ' + item.unit_code,
                            availability_quantity_total: item.availability_quantity_total == undefined? '-' : item.availability_quantity_total + ' ' + item.unit_code,
                            inventory_age: item.inventory_age == undefined? '-' : item.inventory_age,
                            zu_in_stock_quantity: item.zu_in_stock_quantity == undefined? '-' : item.zu_in_stock_quantity,
                        })

                        console.log(table.value.datas,'table.value.datas')

                        if(!version_arr.includes(item.hf_version)){
                            version_arr.push(item.hf_version)
                        }
                        if(!color_arr.includes(item.frame_color)){
                            color_arr.push(item.frame_color)
                        }
                        if(!type_arr.includes(item.frame_shape)){
                            type_arr.push(item.frame_shape)
                        }
                        if(!size_arr.includes(item.frame_size)){
                            size_arr.push(item.frame_size)
                        }

                        console.log(version_arr, color_arr, type_arr, size_arr, 'size_arr')

                        table.value.columns.forEach(i=>{
                            if(i.key == 'hf_version'){
                                i.filterable.filters = []
                                version_arr.forEach(m=>{
                                    i.filterable.filters.push({
                                        text: m,
                                        value: m,
                                    })
                                })
                            } 
                            if(i.key == 'frame_color'){
                                i.filterable.filters = []
                                color_arr.forEach(m=>{
                                    i.filterable.filters.push({
                                        text: m,
                                        value: m,
                                    })
                                })
                            } 
                            if(i.key == 'frame_shape'){
                                i.filterable.filters = []
                                type_arr.forEach(m=>{
                                    i.filterable.filters.push({
                                        text: m,
                                        value: m,
                                    })
                                })
                            } 
                            if(i.key == 'frame_size'){
                                i.filterable.filters = []
                                size_arr.forEach(m=>{
                                    i.filterable.filters.push({
                                        text: m,
                                        value: m,
                                    })
                                })
                            } 
                        })
                    })
            }else{
                    table.value.datas = []
            }
    }

    // 获取产品列表 detail
    const getProductList = async ()=>{
        let param = {
            category_code:'627.501',
            need_back_order_flag: 1,
        }
        if(queryForm.formData.warehouse.length > 0) param.warehouse = queryForm.formData.warehouse
        table.value.configs.loading = true

        let res = await ProductApi.getInstance().getProductQuery(param)
        if(res.code == 0){
            table.value.datas = []
            for(let key in res.data){
                modelTypeKey.value.push(key)
            }
            listData.value = res.data == undefined? null : res.data
            console.log(listData.value,'listData.value')
            selectModel()
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取产品列表，按车型归集  summary
    const getProductByModel = async ()=>{
        let param = {
            category_code:'627.501',
            need_back_order_flag: 1,
        }
        if(queryForm.formData.warehouse.length > 0) param.warehouse = queryForm.formData.warehouse
        allTable.value.configs.loading = true

        let res = await ProductApi.getInstance().getProductByModel(param)
        if(res.code == 0){
            allTable.value.datas = []
            for(let key in res.data){
                res.data[key].forEach((item,index)=>{
                    item.length = res.data[key].length - 1
                    item.firstFlag = index == 0
                    item.hfVersionTTLFlag = item.hf_version == 'TTL'
                    item.produce_quantity_total = item.produce_quantity_total == undefined? '-' : item.produce_quantity_total
                    allTable.value.datas.push(item)
                })
            }
            allTable.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取仓库
    const getWarehouse = async ()=>{
        let res = await ProductApi.getInstance().getWarehouse()
        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'warehouse')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                if(i.subinventory_name == 'HFFG01' || i.subinventory_name == 'HF_OP01'){
                    item.options.push({
                        label: i.description,
                        value: i.subinventory_name,
                    })
                }
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 处理查询面板伸缩时表格高度
    const resetTableHeight = (clientHeight)=>{
        const headerHeight = document.querySelector('.arco-layout-header').clientHeight
        const breadcrumbHeight = document.querySelector('.arco-page-header-with-breadcrumb').clientHeight
        const searchContentDomHeight = 0
        const pageHeight = 30
        const footerHeight = document.querySelector('.footer').clientHeight
        table.value.configs.scroll.y = clientHeight - headerHeight - breadcrumbHeight - searchContentDomHeight - pageHeight - footerHeight - 150
        allTable.value.configs.scroll.y = clientHeight - headerHeight - breadcrumbHeight - searchContentDomHeight - pageHeight - footerHeight - 130
    }

    watch(localeStore,(val)=>{
        resetTableHeight(val.clientHeight)
    })

    onMounted(()=>{ 
        getProductList()
        getProductByModel()
        getWarehouse()

        nextTick(()=>{
            const clientHeight = document.body.clientHeight
            resetTableHeight(clientHeight)
        })
    })

</script>

<style lang="less" scoped>
.tab{
    background: #fff;
}

.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:14;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        flex:1;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left:1px solid #eee;
        padding-left:5px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    /deep/ .arco-form-item-layout-inline{
        margin-right: 0;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-tabs-content {
    padding-top: 0;
}

/deep/ .arco-table-td{
    border-right: 1px solid #eee;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    font-size: 13px;
    font-weight: 600;
}

/deep/ .arco-table-cell{
    padding:8px 16px !important;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/ .arco-pagination{
    display: none;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}


/deep/ .arco-form-item-layout-inline{
    // margin-right:10px;
}

.searchFilter{
    padding: 20px;
    background: #fff;
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.12), 0px 15px 35px 0px rgba(60, 66, 87, 0.08);
}

.size_tab{
    margin-top: 5px;
    border-top: 1px solid #eee;
}

/deep/ .TTLRow{
    font-weight: 600 !important;
    
    .arco-table-td{
        background: #eee !important;

        .arco-table-cell{
            padding:0px 16px !important;
        }
    }
}

</style>